import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignLanguage } from "@fortawesome/free-solid-svg-icons";
import { modulo2 } from "../../../routes/Module2";
import Imagen2 from "../../../images/modulo2/casa.png";
import Imagen4 from "../../../images/modulo2/libro.png";
import Imagen5 from "../../../images/modulo2/arbol.png";
import Imagen6 from "../../../images/modulo2/hospital.png";
import Imagen7 from "../../../images/modulo2/comisaria.png";
import Imagen8 from "../../../images/modulo2/mercadoicon.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo2/Actividad 8.mp3";

import Sidebar from "../Sidebar";
import { Draggable } from "drag-react";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad8 = () => {
  const infoUnidad = modulo2.content[0];
  const infoAct = modulo2.content[0].activities[7];
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title:
        modulo2.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `Cierre`,
    linkNext: `${modulo2.url}/cierre`,
    titlePrev: `${modulo2.content[0].activities[6].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[6].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title} - ${infoAct.name}`,
    name: modulo2.title
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo2.color} hat-text`}>
          <FontAwesomeIcon icon={faSignLanguage} /> Hacemos
        </small>
      </p>

      <h2 className="mb-5">Actividad 8</h2>
      <AudioPlayer track={Audio} />

      <ul>
        <li>Ahora construirás el plano de un barrio.</li>
        <li>
          Arrastra cada imagen del recuadro al lugar que le corresponde en el
          mapa guiándote por esta clave:
        </li>
      </ul>
      <div className="position-relative">
        <div className="task-indications">
          <div className="row mt-5">
            <div className="col-lg-2 col-md-4 col-12 offset-lg-1 offset-0">
              <strong>A4 =</strong> <img src={Imagen5} className="w-90" alt="img" width={40} />
            </div>
            <div className="col-lg-2 col-md-4 col-12">
              <strong>B4 =</strong> <img src={Imagen2} alt="img" width={40} />
            </div>
            <div className="col-lg-2 col-md-4 col-12">
              <strong>D4 =</strong> <img src={Imagen4} alt="img" width={50} />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-lg-2 col-md-4 col-12 offset-lg-1 offset-0">
              <strong>B2 =</strong> <img src={Imagen6} alt="img" width={50} />
            </div>
            <div className="col-lg-2 col-md-4 col-12">
              <strong>C3 =</strong> <img src={Imagen7} alt="img" width={30} />
            </div>
            <div className="col-lg-2 col-md-4 col-12">
              <strong>E1 =</strong> <img src={Imagen8} alt="img" width={80} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-12 col-md-12">
            <div className="container-stickers mt-5 mb-3 border rounded shadow-sm bg-light">
              <Draggable
                style={{
                  position: "absolute",
                  left: "5%",
                  top: "20%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen2} alt="img" width={50} />
                <div>Vivienda</div>
              </Draggable>
              <Draggable
                style={{
                  position: "absolute",
                  left: "21%",
                  top: "30%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen4} alt="img" width={60} />
                <div>Escuela</div>
              </Draggable>
              <Draggable
                style={{
                  position: "absolute",
                  left: "36%",
                  top: "18%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen5} alt="img"  width="74" />
                <div>Parque</div>
              </Draggable>
              <Draggable
                style={{
                  position: "absolute",
                  left: "50%",
                  top: "25%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen6} alt="img" width={50} />
                <div>Posta</div>
              </Draggable>
              <Draggable
                style={{
                  position: "absolute",
                  left: "63%",
                  top: "25%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen7} alt="img" width={40} />
                <div>Comisaría</div>
              </Draggable>
              <Draggable
                style={{
                  position: "absolute",
                  left: "80%",
                  top: "30%",
                  textAlign: "center",
                }}
              >
                <img src={Imagen8} alt="img" width={90} />
                <div>Mercado</div>
              </Draggable>
            </div>
          </div>
        </div>
        <ul className="mt-4">
          <li>Observa el ejemplo del parque.</li>
        </ul>
        <table className="crucigrama crucigrama-bg mt-4">
          <tbody>
            <tr>
              <td className="crucigrama-legend">5</td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
            </tr>
            <tr>
              <td className="crucigrama-legend">4</td>
              <td className="">
                <img src={Imagen5} alt="img" width={75} />
              </td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
            </tr>
            <tr>
              <td className="crucigrama-legend">3</td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
            </tr>
            <tr>
              <td className="crucigrama-legend">2</td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
            </tr>
            <tr>
              <td className="crucigrama-legend">1</td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
              <td className=""></td>
            </tr>
            <tr>
              <td className="crucigrama-legend align-top"></td>
              <td className="crucigrama-legend align-top">A</td>
              <td className="crucigrama-legend align-top">B</td>
              <td className="crucigrama-legend align-top">C</td>
              <td className="crucigrama-legend align-top">D</td>
              <td className="crucigrama-legend align-top">E</td>
            </tr>
          </tbody>
        </table>
      </div>

      <GuiaDocente>
        <p>
          Explique que ahora ubicarán algunos lugares en un plano. Lea las
          indicaciones. Explique que la leyenda les ofrece una clave con la
          ubicación de los lugares. Muestre el ejemplo con la ubicación del
          parque. Ayude a resolver la actividad.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
